<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="free-member flex-center" @touchmove.prevent>
      <img src="https://files.wondercv.com/wondercv_qrcode.png"
        alt="">
      <p @click="buyMember">了解会员计划 >></p>
    </div>
  </w-dialog>
</template>

<script>
import WDialog from '@/components/global/w-dialog'
import { envMixin } from '@/assets/js/mixin/global'
export default {
  mixins: [envMixin],
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  mounted () { },
  components: {
    WDialog
  },
  watch: {},
  computed: {},
  methods: {
    buyMember () {
      if (this.isWxMini) {
        if (this.mobileOS === 'iOS') {
          this.$wechat.miniProgram.navigateTo({
            // url: `/pages/customService/customService`
            url: `/pages/memberPay/memberPay`
          })
        } else {
          this.$router.push('/buy/member/order')
        }
      } else {
        // window.location.href = `${process.env.VUE_APP_HOST}/buy/member/order`
        this.$router.push('/buy/member/order')
      }
      // this.routeTo('/account/users/buy_member')
    },
    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/global/variable';
.free-member {
  position: relative;
  img {
    width: 80vw;
  }
  p {
    position: absolute;
    bottom: 20px;
    color: $color-light;
  }
}
</style>
